import { cn } from "@utils/cn.ts";
import React from "react";

/**
 * 위반사항 표시 토글 버튼들
 * - 원티드 반영사항 보기
 * - 최소인원 위반사항 보기
 * - 설정 위반사항 보기
 *
 * 상태를 prop으로 받아서 근무표 만들기(전역 상태)와 조정판(로컬 상태)을 분리
 */

function ViolationToggleButtons({
  hideManpowerToggle = false,
  hideWantedToggle = false,
  showManpowerViolations,
  showConfigViolations,
  showWantedViolations,
  toggleManpowerViolations,
  toggleConfigViolations,
  toggleWantedViolations,
}: {
  hideManpowerToggle?: boolean;
  hideWantedToggle?: boolean;
  showManpowerViolations: boolean;
  showConfigViolations: boolean;
  showWantedViolations: boolean;
  toggleManpowerViolations: () => void;
  toggleConfigViolations: () => void;
  toggleWantedViolations: () => void;
}) {
  // 표시할 버튼 개수에 따라 grid-rows 조정
  const visibleButtonCount =
    3 - (hideManpowerToggle ? 1 : 0) - (hideWantedToggle ? 1 : 0);

  return (
    <>
      <section
        className={cn(
          "grid! gap-1",
          visibleButtonCount === 3 && "grid-rows-3 h-[150px]",
          visibleButtonCount === 2 && "grid-rows-2 h-[100px]",
          visibleButtonCount === 1 && "grid-rows-1 h-[50px]"
        )}
      >
        {!hideManpowerToggle && (
          <button
            type="button"
            onClick={toggleManpowerViolations}
            className={cn(
              "p-1.5 text-center rounded-sm border w-full text-xs! transition-colors",
              showManpowerViolations
                ? "bg-blue-50 border-blue-300 text-blue-700 hover:bg-blue-100"
                : "text-gray-400 hover:text-zinc-800 hover:border-zinc-400"
            )}
          >
            최소인원 위반사항 보기
          </button>
        )}

        <button
          type="button"
          onClick={toggleConfigViolations}
          className={cn(
            "p-1.5 text-center rounded-sm border w-full text-xs! transition-colors",
            showConfigViolations
              ? "bg-blue-50 border-blue-300 text-blue-700 hover:bg-blue-100"
              : "text-gray-400 hover:text-zinc-800 hover:border-zinc-400"
          )}
        >
          설정 위반사항 보기
        </button>

        {/* 원티드 반영사항 보기 (조정판에서는 숨김) */}
        {!hideWantedToggle && (
          <button
            type="button"
            onClick={toggleWantedViolations}
            className={cn(
              "py-3 text-center rounded-sm border w-full text-xs! transition-colors",
              showWantedViolations
                ? "bg-blue-50 border-blue-300 text-blue-700 hover:bg-blue-100"
                : "text-gray-400 hover:text-zinc-800 hover:border-zinc-400"
            )}
          >
            원티드 반영사항 보기
          </button>
        )}
      </section>
    </>
  );
}

export default React.memo(ViolationToggleButtons);
